import _extends from "@babel/runtime/helpers/extends";
import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { EnumInvoiceStatus } from 'api';
import { getInvoicesByAccountIdAndStatus } from 'api/invoices/getInvoicesByAccountIdAndStatus';
import { EditButton } from 'components/Button';
import Divider from 'components/Divider/Divider';
import Spinner from 'components/Spinner/Spinner';
import Title from 'components/Text/Title';
import VehicleCard from 'components/VehicleCard/VehicleCard';
import VehicleCardNoObe from 'components/VehicleCard/VehicleCardNoObe';
import { EDIT_AGREEMENT } from 'routes/overview/paths';
import { isAgreementStatusEditable } from 'utils/agreements/isAgreementInactive';
import checkLoadable from 'utils/recoil/checkLoadable';
import useStyles from '../AgreementStyles';
import AgreementInfo from './AgreementInfo';
export default function Agreement(agreement) {
  const {
    push
  } = useHistory();
  const {
    t
  } = useTranslation();
  const {
    vehicleCardWrapper
  } = useStyles();
  const invoicesLoadable = useRecoilValueLoadable(getInvoicesByAccountIdAndStatus({
    accountId: agreement.accountRef,
    invoiceStatus: EnumInvoiceStatus.ClosedByDebtCollector
  }));
  const {
    loading,
    contents: invoices
  } = checkLoadable(invoicesLoadable);
  const invoicesCount = invoices?.totalResults ?? 0;
  if (loading) return /*#__PURE__*/React.createElement(Spinner, null);
  return /*#__PURE__*/React.createElement("div", {
    className: vehicleCardWrapper
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(EditButton, {
    onClick: () => {
      if (agreement.id) push(EDIT_AGREEMENT(agreement.id));
    },
    disabled: !isAgreementStatusEditable(agreement.status)
  }, t('agreements.edit_agreement'))), /*#__PURE__*/React.createElement(AgreementInfo, _extends({}, agreement, {
    hasClosedInvoices: invoicesCount > 0,
    totalVehicles: `${agreement.obes ? agreement.obes.length : 0}`
  })), !(agreement.obes?.length === 0) && /*#__PURE__*/React.createElement(Title, null, t('titles.obe')), agreement.obes?.map(obe => /*#__PURE__*/React.createElement("div", {
    key: obe.obeId
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(VehicleCard, obe))), !(agreement.pendingorders?.length === 0) && /*#__PURE__*/React.createElement(Title, null, t('titles.pending_orders')), agreement.pendingorders?.map(order => /*#__PURE__*/React.createElement("div", {
    key: order.id
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(VehicleCardNoObe, order))));
}